import { createTheme } from "@material-ui/core/styles";

declare module '@material-ui/core/styles/createPalette' {
  interface Palette {
    white: Palette['primary'];
    gray1: Palette['primary'];
    gray5: Palette['primary'];
    darkPastelGreen: Palette['primary'];
    lightishPurple: Palette['primary'];
    hierarchyChartPurple: Palette['primary'];
    hierarchyChartGreen: Palette['primary'];
    hierarchyChartBlue: Palette['primary'];
    hierarchyChartOrange: Palette['primary'];
    hierarchyChartMustardYellow: Palette['primary'];
    hierarchyChartPink: Palette['primary'];
    hierarchyChartLightGray: Palette['primary'];
    hierarchyChartDarkGray: Palette['primary'];
    hierarchyChartBlack: Palette['primary'];
    hierarchyChartDarkBlack: Palette['primary'];
    hierarchyChartLighterGray: Palette['primary'];
    constrastGreyLighter: Palette['primary'];
    constrastGreyLight: Palette['primary'];
    constrastGreyNormal: Palette['primary'];
    constrastGreyDark: Palette['primary'];
    constrastGreyDarker: Palette['primary'];
    constrastGreyBlack: Palette['primary'];
    subMenusColor: Palette['primary'];
    lowerToolBarContainerColor: Palette['primary'];
    appBarsColor: Palette['primary'];
    brandBKColors: Palette['primary'];
    brandPLKColors: Palette['primary'];
    brandTHColors: Palette['primary'];
  }
  interface PaletteOptions {
    white: PaletteOptions['primary'];
    gray1: PaletteOptions['primary'];
    gray5: PaletteOptions['primary'];
    darkPastelGreen: PaletteOptions['primary'];
    lightishPurple: PaletteOptions['primary'];
    hierarchyChartPurple: PaletteOptions['primary'];
    hierarchyChartGreen: PaletteOptions['primary'];
    hierarchyChartBlue: PaletteOptions['primary'];
    hierarchyChartOrange: PaletteOptions['primary'];
    hierarchyChartMustardYellow: PaletteOptions['primary'];
    hierarchyChartPink: PaletteOptions['primary'];
    hierarchyChartLightGray: PaletteOptions['primary'];
    hierarchyChartDarkGray: PaletteOptions['primary'];
    hierarchyChartBlack: PaletteOptions['primary'];
    hierarchyChartDarkBlack: PaletteOptions['primary'];
    hierarchyChartLighterGray: PaletteOptions['primary'];
    constrastGreyLighter: PaletteOptions['primary'];
    constrastGreyLight: PaletteOptions['primary'];
    constrastGreyNormal: PaletteOptions['primary'];
    constrastGreyDark: PaletteOptions['primary'];
    constrastGreyDarker: PaletteOptions['primary'];
    constrastGreyBlack: PaletteOptions['primary'];
    lowerToolBarContainerColor: PaletteOptions['primary'];
    appBarsColor: PaletteOptions['primary'];
    subMenusColor: PaletteOptions['primary'];
    brandBKColors: PaletteOptions['primary'];
    brandPLKColors: PaletteOptions['primary'];
    brandTHColors: PaletteOptions['primary'];
  }
}

const hexColorWhite = '#FFFFFF';
const gray1 = {
  main: '#4f4f4f',
  dark: '#707070',
  light: '#707070',
};
const gray5 = {
  main: '#f2f2f2',
  dark: '#4f4f4f',
  light: '#f2f2f2',
};
const darkPastelGreen = {
  main: '#55b757',
};
const lightishPurple = {
  main: '#9945e9',
};

const hierarchyChartPurple = { main: '#9945E9' };
const hierarchyChartGreen = { main: '#55B757' };
const hierarchyChartBlue = { main: '#0037C2' };
const hierarchyChartOrange = { main: '#F57C00' };
const hierarchyChartMustardYellow = { main: '#DAA520' };
const hierarchyChartPink = { main: '#E945E9' };
const hierarchyChartLightGray = { main: '#92A7BA' };
const hierarchyChartDarkGray = { main: '#6B7A99' };
const hierarchyChartBlack = { main: '#30323E' };
const hierarchyChartDarkBlack = { main: '#131417' };
const hierarchyChartLighterGray = { main: '#BDBDBD' };

const constrastGreyLighter = { main: '#f7f9fa' };
const constrastGreyLight = { main: '#f1f3f4' };
const constrastGreyNormal = { main: '#e3e5e6' };
const constrastGreyDark = { main: '#c6cacc' };
const constrastGreyDarker = { main: '#919699' };
const constrastGreyBlack = { main: '#3e4345' };
const brandBKColors = { main: '#d62300', dark: '#fd8330', light: '#ffffff' };
const brandPLKColors = { main: '#ff7d00', dark: '#e75200', light: '#be5a09' };
const brandTHColors = { main: '#c8102e', dark: '#96071e', light: '#ffffff' };

export const ThemeDefault = createTheme({
  palette: {
    primary: {
      main: constrastGreyBlack.main,
    },
    secondary: {
      main: constrastGreyBlack.main,
    },
    white: {
      main: hexColorWhite,
    },
    lowerToolBarContainerColor: {
      main: constrastGreyLighter.main,
    },
    subMenusColor: {
      main: constrastGreyDark.main,
    },
    appBarsColor: {
      main: constrastGreyDark.main,
    },
    brandBKColors,
    brandPLKColors,
    brandTHColors,
    gray1,
    gray5,
    darkPastelGreen,
    lightishPurple,
    hierarchyChartPurple,
    hierarchyChartGreen,
    hierarchyChartBlue,
    hierarchyChartOrange,
    hierarchyChartMustardYellow,
    hierarchyChartPink,
    hierarchyChartLightGray,
    hierarchyChartDarkGray,
    hierarchyChartBlack,
    hierarchyChartDarkBlack,
    hierarchyChartLighterGray,
    constrastGreyLighter,
    constrastGreyLight,
    constrastGreyNormal,
    constrastGreyDark,
    constrastGreyDarker,
    constrastGreyBlack,
  },
  typography: {
    button: {
      textTransform: 'none',
    },
  },
  overrides: {
    MuiTextField: {
      root: {
        backgroundColor: constrastGreyLighter.main,
      },
    },
    MuiButton: {
      outlined: {
        backgroundColor: constrastGreyNormal.main,
      },
      label:{
        textTransform: 'none'
      }
    },
    MuiInputLabel: {
      shrink: {
        backgroundColor: constrastGreyNormal.main,
        color: constrastGreyBlack.main,
      },
    },
    MuiDivider: {
      root: {
        height: 2,
      },
    },
    MuiDialogTitle: {},
    MuiDialogContent: {
      root: {},
    },
    MuiDialogActions: {
      root: {},
    },
    MuiTableRow: {
      root: {
        root: {
          backgroundColor: constrastGreyNormal.main,
        },
      },
    },
    MuiTableCell: {
      stickyHeader: {
        backgroundColor: constrastGreyNormal.main,
      },
    },
  },
});
